__turbopack_context__.v({
  "DownloadLinkList": "YUTeWG_DownloadLinkList",
  "DownloadLinkList__Buttons": "YUTeWG_DownloadLinkList__Buttons",
  "DownloadLinkList__Container": "YUTeWG_DownloadLinkList__Container",
  "DownloadLinkList__Item": "YUTeWG_DownloadLinkList__Item",
  "DownloadLinkList__Link": "YUTeWG_DownloadLinkList__Link",
  "DownloadLinkList__LinkIcon": "YUTeWG_DownloadLinkList__LinkIcon",
  "DownloadLinkList__List": "YUTeWG_DownloadLinkList__List",
  "DownloadLinkList__ListContainer": "YUTeWG_DownloadLinkList__ListContainer",
  "DownloadLinkList__Tab": "YUTeWG_DownloadLinkList__Tab",
  "DownloadLinkList__Tab--Active": "YUTeWG_DownloadLinkList__Tab--Active",
  "DownloadLinkList__TabContainer": "YUTeWG_DownloadLinkList__TabContainer",
  "DownloadLinkList__TabTitle": "YUTeWG_DownloadLinkList__TabTitle",
  "DownloadLinkList__Title": "YUTeWG_DownloadLinkList__Title",
  "DownloadLinkList__Wrapper": "YUTeWG_DownloadLinkList__Wrapper",
});
